/** ParsedGame freshness for Force re-parse (ADR 0014). */

/** Must match replays_service/domain/entities.SchemaVersion. */
export const CURRENT_PARSED_GAME_SCHEMA_VERSION = 6;

/**
 * True when Production Intervals are missing or the document predates
 * classification (schema_version < current).
 */
export function needsForceReparse(parsedGameOrBuildOrder, schemaVersion) {
  const version =
    typeof schemaVersion === 'number'
      ? schemaVersion
      : typeof parsedGameOrBuildOrder?.schema_version === 'number'
        ? parsedGameOrBuildOrder.schema_version
        : 0;
  if (version < CURRENT_PARSED_GAME_SCHEMA_VERSION) {
    return true;
  }
  const buildOrder = parsedGameOrBuildOrder?.production_intervals
    ? parsedGameOrBuildOrder
    : null;
  // When called with a build order only, intervals check still applies.
  const intervals = buildOrder
    ? buildOrder.production_intervals
    : parsedGameOrBuildOrder?.build_orders?.[0]?.production_intervals;
  if (buildOrder && !Array.isArray(buildOrder.production_intervals)) {
    return true;
  }
  if (!buildOrder && parsedGameOrBuildOrder?.build_orders) {
    return parsedGameOrBuildOrder.build_orders.some(
      (bo) => !Array.isArray(bo.production_intervals)
    );
  }
  if (buildOrder === null && !Array.isArray(intervals) && parsedGameOrBuildOrder) {
    // Single build-order shaped object without schema on itself.
    if (!Array.isArray(parsedGameOrBuildOrder.production_intervals)) {
      return true;
    }
  }
  return false;
}

/** @deprecated use needsForceReparse — kept name for call-site clarity in ReplayPlayer */
export function needsProductionTrackReparse(buildOrder, schemaVersion = 0) {
  if (!buildOrder) return true;
  if (schemaVersion < CURRENT_PARSED_GAME_SCHEMA_VERSION) return true;
  return !Array.isArray(buildOrder.production_intervals);
}
